module.exports = __webpack_public_path__ + "static/img/AS.0ac165c3.svg";